import { Clickable } from '@routable/gross-ds';
import React from 'react';
const ItemWithoutContactsHint = ({ onCreateContact }) => (React.createElement("div", { className: "text-sm text-black" },
    "No payment notification will be sent.",
    ' ',
    React.createElement(Clickable, { onClick: onCreateContact, variant: "black" }, "Add a contact to notify")));
export default ItemWithoutContactsHint;
